import { useEffect, useRef, useState } from "react";

export const MARKETS = [
    { symbol: "BTC/USDT", name: "Bitcoin", base: 67842.16, change: 2.34, decimals: 2, seed: 42 },
    { symbol: "ETH/USDT", name: "Ethereum", base: 3247.85, change: 1.82, decimals: 2, seed: 7 },
    { symbol: "BNB/USDT", name: "BNB", base: 592.45, change: 1.24, decimals: 2, seed: 77 },
    { symbol: "SOL/USDT", name: "Solana", base: 172.36, change: -0.42, decimals: 2, seed: 91 },
    { symbol: "XRP/USDT", name: "XRP", base: 0.6124, change: 1.1, decimals: 4, seed: 55 },
];

export const fmt = (v, d = 2) =>
    v.toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export const fmtChange = (c) => `${c >= 0 ? "+" : ""}${c.toFixed(2)}%`;

/* Deterministic pseudo-random generator so every chart looks the same each render */
export const mulberry32 = (a) => () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

export const seededSeries = (seed, n = 32, volatility = 1) => {
    const rnd = mulberry32(seed);
    const out = [];
    let v = 50;
    for (let i = 0; i < n; i++) {
        v += (rnd() - 0.48) * 11 * volatility;
        v = Math.max(8, Math.min(92, v));
        out.push(v);
    }
    return out;
};

export const hashStr = (s) =>
    s.split("").reduce((acc, ch) => (acc * 31 + ch.charCodeAt(0)) | 0, 7);

const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

/* Simulated price tick engine — DEMO DATA ONLY, no real exchange API */
export function useTickMarkets(interval = 1900) {
    const [quotes, setQuotes] = useState(() =>
        Object.fromEntries(
            MARKETS.map((m) => [m.symbol, { price: m.base, change: m.change, dir: 1 }])
        )
    );
    const seedRef = useRef(1);

    useEffect(() => {
        const id = setInterval(() => {
            seedRef.current += 1;
            setQuotes((prev) => {
                const next = {};
                for (const m of MARKETS) {
                    const p = prev[m.symbol];
                    const rnd = mulberry32(m.seed + seedRef.current * 97);
                    const drift = (rnd() - 0.48) * 0.0032;
                    const price = Math.max(0.0001, p.price * (1 + drift));
                    next[m.symbol] = {
                        price,
                        change: clamp(
                            p.change + drift * 42,
                            m.change - 1.4,
                            m.change + 1.4
                        ),
                        dir: price >= p.price ? 1 : -1,
                    };
                }
                return next;
            });
        }, interval);
        return () => clearInterval(id);
    }, [interval]);

    return quotes;
}
